import React, {useState,useEffect} from "react";
import Pishfactorlist from "./Pishfactorlist";
import Createnewpishfactor from "./Createnewpishfactor";
import {Navigate} from "react-router-dom";
import Appbar from "../Appbar";

const Pishfactor = ({isMobile})=>{
    const [change , setChange] = React.useState(false);
    const [btnedit, setBtnedit] = React.useState(false);
    const [key , setKey] = React.useState([""]);
    const [customername , setCustomername] = React.useState([]);
    const [customertel , setCustomertel] = React.useState([]);
    const [isLogin , setIsLogin] = useState(localStorage.getItem("token"));

    useEffect(()=>{
        if (change === true)
            setChange(false);
    },[change])
    const Redirect = ()=>{
        return (<Navigate replace to="/login" />)
    }
    return(
        <div style={{width:!isMobile ? "calc(100% - 240px)" : ""}}>
            {!(!!isLogin)  ? <Redirect/> : ''}
            <Appbar isMobile={isMobile}/>
            <Createnewpishfactor
                change={change}
                setchange={setChange}
                btnedit={btnedit}
                setbtnedit={setBtnedit}
                editcustomername={customername}
                editcustomertel={customertel}
                editkeycode={key}
                setkeycode={setKey}
                isMobile={isMobile}
            />
            <Pishfactorlist
                change={change}
                setchange={setChange}
                btnedit={setBtnedit}
                setcustomername={setCustomername}
                setcustomertel={setCustomertel}
                setkey={setKey}
            />
        </div>
    )
}
export default Pishfactor